export default {"src":"/_next/static/media/icn-arrow.da2fca00.svg","height":24,"width":24};